import React from 'react';
import './App.css';

export const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-section">
        <div className="footer-project-info">
          <h4>Radonek – wirtualny asystent pacjenta u onkologa – radioterapeuty</h4>
          <p className="funding-info">
            Projekt finansowany ze środków budżetu państwa, przyznanych przez Ministra Nauki w ramach Programu „Studenckie koła naukowe tworzą innowacje"
          </p>
          <p className="contract-info">
            Umowa Nr SKN/SP/601573/2024 z dnia 15.06.2024
          </p>
        </div>
        <div className="footer-logos">
          <img src="/footer.png" alt="Logotypy sponsorów i partnerów projektu" className="footer-sponsors-logo" />
        </div>
      </div>
      <div className="footer-section">
        <strong>Administrator systemu:</strong>
        <p>dr n. med. Konrad Stawiski - lekarz specjalista radioterapii onkologicznej</p>
        <div className="footer-links">
          <a href="https://www.radioonkolog.pl" target="_blank" rel="noopener noreferrer">
            www.radioonkolog.pl
          </a>
          <span className="separator">|</span>
          <a href="mailto:konrad@radioonkolog.pl">
            konrad@radioonkolog.pl
          </a>
        </div>
        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} Radonek. Wszelkie prawa zastrzeżone.</p>
        </div>
      </div>
    </div>
  </footer>
);
